<script>
export default {
  name: 'ReviewAvailableDomainsSettingsTable',
  props: {
    availableDomains: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('reviewSettings.table.headers.domainId'),
          value: 'domain.id',
        },
        {
          text: this.$t('reviewSettings.table.headers.domainName'),
          value: 'domain.id',
        },
        {
          text: this.$t('reviewSettings.table.headers.domainShortName'),
          value: 'domain.id',
        },
        {
          text: this.$t('reviewSettings.table.headers.availableDomainId'),
          value: 'availableDomain.id',
        },
        {
          text: this.$t('reviewSettings.table.headers.availableDomainName'),
          value: 'availableDomain.id',
        },
        {
          text: this.$t('reviewSettings.table.headers.availableDomainShortName'),
          value: 'availableDomain.id',
        },
        {
          text: this.$t('reviewSettings.table.headers.delete'),
          value: 'delete',
          sortable: false,
        },
      ],
    };
  },
};
</script>

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="availableDomains"
      :rows-per-page-items="[10, 15, 20, { text: $t('reviewSettings.table.all'), value:-1 }]"
      :rows-per-page-text="$t('reviewSettings.table.rowsPerPageText')"
      class="elevation-0 mx-5"
      sort-icon="keyboard_arrow_up"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.domain.id }}</td>
        <td class="text-xs-left">{{ props.item.domain.name }}</td>
        <td class="text-xs-left">{{ props.item.domain.shortName }}</td>
        <td class="text-xs-right">{{ props.item.availableDomain.id }}</td>
        <td class="text-xs-left">{{ props.item.availableDomain.name }}</td>
        <td class="text-xs-left">{{ props.item.availableDomain.shortName }}</td>
        <td class="align-content-center">
          <v-btn
            @click="$emit('delete', props.item)"
            :disabled="props.item.domain.id === props.item.availableDomain.id"
            :loading="loading"
            flat
            icon
          >
            <v-icon>delete_outline</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewAvailableDomainsSettingsTable.vue